import { render } from "./ChatButton.vue?vue&type=template&id=bb62f6b0"
import script from "./ChatButton.vue?vue&type=script&lang=js"
export * from "./ChatButton.vue?vue&type=script&lang=js"

import "./ChatButton.vue?vue&type=style&index=0&id=bb62f6b0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__